import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { KeyboardArrowUp } from "@mui/icons-material";

const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Funzione per gestire lo scroll verso l'alto
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Effetto per mostrare/nascondere il bottone in base alla posizione dello scroll
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > 300); // Mostra il bottone dopo 300px di scroll
    };

    window.addEventListener("scroll", handleScroll);

    // Pulizia dell'event listener quando il componente viene smontato
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <Button
          onClick={scrollToTop}
          variant="contained"
          color="primary"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 1000,
            borderRadius: "50%",
            width: "60px",
            height: "60px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <KeyboardArrowUp fontSize="large" />
        </Button>
      )}
    </>
  );
};

export default ScrollToTopButton;
